import styled from 'styled-components';

export const CardButton = styled.button`
  margin-top: 25px;
  width: 100%;
  height: 82px;
  background: var(--background);
  border: 1px solid var(--borders);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  &.green {
    background: var(--background);
  border: 1px solid var(--apple);
  }
  &:hover {
    box-shadow: inset 0px 0px 25px var(--inner-shadow-colour);
  }
`;
